<app-menu-toggle
  [icon]="orthographicView ? 'perspective' : 'orthographic'"
  [matTooltip]="
    'Switch to ' + (orthographicView ? 'perspective' : 'orthographic') + ' view'
  "
  (click)="switchMainView()"
>
</app-menu-toggle>
